<app-rad-base-modal
    #radBaseModal
    [identifier]="modalType"
    [closable]="closable"
    [closeButtonText]="closeButtonText"
    [confirmButtonText]="confirmButtonText"
    [disableConfirmButton]="disableConfirmButton"
    [title]="title"
>
    <div class="edit-all-fields-modal">
        <p class="edit-all-fields-modal__subtitle">{{ subtitle }}</p>
        
        <div class="edit-all-fields-modal__fields">
            <ng-template #fieldsContainer></ng-template>
        </div>
    </div>
</app-rad-base-modal>

